import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; 
import Swal from "sweetalert2";
import "datatables.net-bs5";
import "react-loading-skeleton/dist/skeleton.css";

const MstTes = () => {
    const [pembelajaran, setPembelajaran] = useState([]); 
   

    const [formData, setFormData] = useState({
      
        kode_mst_ujian:"", nama_master:"", tgl_mulai:"", tgl_selesai:""

    }); // State untuk menyimpan daftar kelas
    const [isEditing, setIsEditing] = useState(false);

    const getDataRefrensi = async () => {
        
        try {
                 // Kirim request ke server dengan header level user
                 const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getPembelajaranToUjian`, {
                     method: 'GET',
                     headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
                 });
 
                 if (!response.ok) {
                     throw new Error("Failed to fetch kelas");
                 }
 
                 const data = await response.json();
                 
                 // Menyimpan data kelas ke dalam state
                 setPembelajaran(data.data); 
               
             } catch (error) {
              
                 Swal.fire("Error!", error.message || 'Something went wrong', "error");
             }
     }

    useEffect(() => { 
        getDataRefrensi();
       
        if ($.fn.dataTable.isDataTable('.table')) {
            $('.table').DataTable().destroy();
        }
        console.log("ss")
        $('.table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getMstTes`,
                type: "GET",
              headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
                dataSrc: function(json) {
                      console.log(json)
                    if (!json.data || json.data.length === 0) {
                        return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                    }
                    console.log(json.data)
                    return json.data;
                }
            },
            columns: [
                { 
                    data: null, 
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                         return `<a href="/admin/refrensi/daftartesguru?id=${row.kode_mst_ujian}">${row.kode_mst_ujian}</a>`;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                          const formatTanggal = (tgl) => {
                            const date = new Date(tgl);
                            return date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
                        };

                        return `<b>${row.nama_master}</b> <br> <span class="font-weight-light">${formatTanggal(row.tgl_mulai)} <i class="ti ti-chevron-right"></i> ${formatTanggal(row.tgl_selesai)}</span>`;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b>${row.jumlah_ujian}</b>`;
                    }
                },
               
                
               
                { 
                    data: null,
                    render: function (data, type, row) {
                        return `
                           <a href="/pendidik/viewevaluasi?id_ujian=${row.id_ujian}" title='Tambah dana Lihat Soal' className="avtar avtar-xs mx-1 btn-link-secondary">
                    <i className="ti ti-eye f-20"></i>
                    </a>
                        `;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row) {
                        return `
                           <a href="/pendidik/viewevaluasi?id_ujian=${row.id_ujian}" title='Tambah dana Lihat Soal' className="avtar avtar-xs mx-1 btn-link-secondary">
                    <i className="ti ti-eye f-20"></i>
                    </a>
                        `;
                    }
                },
             
                { 
                    data: null,
                    render: function (data, type, row) {
                        return `
                            <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
                                <i class="ti ti-edit f-20"></i>
                            </a>
                            <a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.id_ujian}">
                                <i class="ti ti-trash f-20"></i>
                            </a>
                        `;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });
     
        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []);// Inisialisasi ulang hanya ketika `kelas` berubah
    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit({...rowData,
                tgl_mulai:new Date(rowData.tgl_mulai ).toISOString().split('T')[0],
                tgl_selesai:new Date(rowData.tgl_selesai ).toISOString().split('T')[0]
            });
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapusujian`, {
                    method: "POST",
                   headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
                    body: JSON.stringify({ id_ujian : id })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                        $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                    } else {
                        Swal.fire("Gagal!", data.message, "error");
                    }
                })
                .catch(error => {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                });
            }
        });
    });

    useEffect(() => {
        if (formData.id_mapel) {
            // Ambil semua pembelajaran yang sesuai dengan mapel yang dipilih
            const pembelajaranFiltered = pembelajaran?.filter(
                (item) => item.mata_pelajaran_id === formData.id_mapel
            );

            // Ambil semua rombel yang sesuai dengan pembelajaran tersebut
            const rombelIds = pembelajaranFiltered.map((item) => item.mata_pelajaran_id);
            const rombelFiltered = pembelajaran?.filter((rombel) =>
                rombelIds.includes(rombel.mata_pelajaran_id)
            );
            console.log(rombelFiltered)

          
        } 
    }, [formData.id_mapel]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Jika select option yang berubah, simpan juga nama yang dipilih
        if (name === "id_rombel") {
            const selectedRombel =pembelajaran?.find((r) => String(r.rombongan_belajar_id) ===  String(value));
            
            setFormData({
                ...formData,
                id_rombel: value,
                nama_rombel: selectedRombel ? selectedRombel.nama_rombel : "",
                pembelajaran_id: selectedRombel ? selectedRombel.pembelajaran_id : ""
            });
        } else if (name === "id_mapel") {
            const selectedMapel = pembelajaran?.find((m) => String(m.mata_pelajaran_id) ===  String(value));
            setFormData({
                ...formData,
                id_mapel: value,
                nama_mapel: selectedMapel ? selectedMapel.nama_mapel : "",
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        console.log(formData)
        
    };

    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
        console.log(ujian)
    };

    // Reset form untuk tambah data baru
    const handleNew = () => {
        setIsEditing(false);
        setFormData({
            kode_mst_ujian:"", nama_master:"", tgl_mulai:"", tgl_selesai:""
        });
    };
   
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData)

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputmstujian`, {
                method: "POST",
               headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }
            const tombol = document.getElementById('closeidtombol');
            if (tombol) {
              tombol.click();
            }
            const result = await response.json();
            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            
        } catch (error) {
             Swal.fire("Error!", error.response?.data?.message || 'Something went wrong', "error");
           
           
        }
    };

   

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Master Evaluasi / Ujian</h3></div>

                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button></div>
                                    </div>
                                    <hr />
                                   <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                                <th scope="col">Kode</th>
                                                <th scope="col">Nama</th>
                                                <th scope="col">Jumlah Ujian</th>
                                                
                                                <th width="50"><center>Daftar Ujian</center></th>
                                              
                                                <th width="50"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                           
                                        </tbody>
                                    </table>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {isEditing ? "Edit Master Ujian" : "Tambah Master Ujian"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                        <div className="mb-3">
                                <label className="form-label">Nama</label>
                                <input name='nama_master' className="form-control" type="text" placeholder="Nama" value={formData.nama_master} onChange={handleChange} required/>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Mulai</label>
                                <input name='tgl_mulai' className="form-control" type="date" placeholder="Mulai" value={formData.tgl_mulai} onChange={handleChange} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Selesai</label>
                                <input name='tgl_selesai' className="form-control" type="date" placeholder="Selesai" value={formData.tgl_selesai} onChange={handleChange} required/>
                            </div>
                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="closeidtombol" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    );
};

export default MstTes;
